<div [hidden]="!isLoading" [ngClass]="{'overlay-pc': !isMobile, 'overlay-mobile': isMobile}">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>